import { trackLinkEvent, yieldToMainBackground } from "../../common/utils";

function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	// preview immagini nella scheda
	const gallery_preview = document.querySelector("#_gallery-preview");
	if (gallery_preview) {
		import("../../common/image_gallery.js").then((module) => {
			const MovieFreeGLightbox = module.MovieFreeGLightbox;
			const images = [];
			for (const el of document.querySelectorAll("._gallery_img")) {
				images.push({ href: el.dataset.gallerySrc });
			}
			new MovieFreeGLightbox({
				elements: images,
				selector: "#_gallery-preview ._gallery_img",
			});
		});
	}

	// tracciamento streaming
	for (const el of document.querySelectorAll("._streaming_data a")) {
		el.addEventListener("click", () => {
			yieldToMainBackground().then(() => {
				trackLinkEvent("streaming-data-link");
			});
		});
	}

	// Aggiornamento data articoli
	if (document.querySelector("#news")) {
		import("../../common/pubdate.js");
	}
});
